import BodyText from './BodyText';

export default BodyText;
